import { useEffect, useState } from "react";
import Navbar from "../Navbar.jsx";
import Footer from "../Foooter.jsx";
import FooterMovil from "../FooterMovil.jsx";
import api from "../../utils/apiClient";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate, Link } from "react-router-dom";
import { Spin } from "antd";
import "../../style/Stock.css";
import "../../style/MisOfertas.css";

const ESTADO_LABEL = {
  ganando: "Vas ganando",
  superado: "Te superaron",
  participando: "Participando",
  proxima: "Próxima",
  ganada: "¡Ganada!",
  perdida: "No ganada",
  terminada: "Terminada",
};

const GROUPS = [
  { key: "vivo", title: "En curso", estados: ["ganando", "superado", "participando"] },
  { key: "proximas", title: "Próximas", estados: ["proxima"] },
  { key: "terminadas", title: "Terminadas", estados: ["ganada", "perdida", "terminada"] },
];

const formatL = (n) => "L." + Number(n || 0).toLocaleString("en-US");

function fechaCorta(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString("es-HN", { day: "numeric", month: "short" }) +
    " " + d.toLocaleTimeString("es-HN", { hour: "2-digit", minute: "2-digit" });
}

function MisOfertas() {
  const { authToken } = useAuth();
  const navigate = useNavigate();
  const [entries, setEntries] = useState(null); // null = loading

  useEffect(() => {
    if (!authToken) {
      navigate("/login");
      return;
    }
    let cancelled = false;
    api
      .get("auctions/mine")
      .then((res) => { if (!cancelled) setEntries(res.data); })
      .catch((err) => {
        console.error("Error fetching mis ofertas:", err);
        if (!cancelled) setEntries([]);
      });
    return () => { cancelled = true; };
  }, [authToken, navigate]);

  const renderCard = (e) => {
    const car = e.auction.Carro || {};
    const img = typeof car.imagenes?.[0] === "string"
      ? car.imagenes[0].replace("http://", "https://")
      : "";
    const ended = ["ganada", "perdida", "terminada"].includes(e.estado);
    return (
      <Link
        to={"/subasta/" + car._id}
        className="misofertas-card"
        key={e.auction._id}
      >
        <div className="misofertas-img">
          {img ? <img src={img} alt={`${car.marca} ${car.modelo}`} /> : <div className="misofertas-noimg" />}
        </div>
        <div className="misofertas-info">
          <span className="misofertas-lote">LOTE: {car.lote}</span>
          <span className="misofertas-title">
            {car.marca} {car.modelo} {car.anio}
          </span>
          <span className="misofertas-fecha">
            {e.estado === "proxima" ? "Inicia: " : ended ? "Terminó: " : "Termina: "}
            {fechaCorta(e.estado === "proxima" ? e.auction.Inicio : e.auction.Fin)}
          </span>
        </div>
        <div className="misofertas-nums">
          <span className="misofertas-precio">
            {ended ? "Oferta final: " : "Oferta actual: "}
            <b>{formatL(e.auction.highestBid)}</b>
          </span>
          {e.miOferta != null && (
            <span className="misofertas-mia">Tu oferta: {formatL(e.miOferta)}</span>
          )}
          {e.miMaxima != null && (
            <span className="misofertas-mia">
              Tu máxima: {formatL(e.miMaxima.maxAmount)}
              {e.miMaxima.active ? "" : " (agotada)"}
            </span>
          )}
        </div>
        <span className={"misofertas-estado estado-" + e.estado}>
          {ESTADO_LABEL[e.estado]}
        </span>
      </Link>
    );
  };

  return (
    <>
      <Navbar />
      <div className="search-bar">
        <div className="misofertas-head">
          <Link to="/subastas" className="misofertas-back">← Volver a subastas</Link>
          <h1>Mis ofertas</h1>
          <p>Las subastas en las que participas: tus ofertas, tus máximas y cómo vas.</p>
        </div>
      </div>

      <div className="stock-view">
        <div className="misofertas-list">
          {entries === null ? (
            <div className="misofertas-loading"><Spin size="large" /></div>
          ) : entries.length === 0 ? (
            <div className="misofertas-empty">
              <p>Aún no participas en ninguna subasta.</p>
              <Link to="/subastas" className="misofertas-cta">Ver subastas</Link>
            </div>
          ) : (
            GROUPS.map((g) => {
              const items = entries.filter((e) => g.estados.includes(e.estado));
              if (items.length === 0) return null;
              return (
                <section className="misofertas-group" key={g.key}>
                  <h2>{g.title}</h2>
                  {items.map(renderCard)}
                </section>
              );
            })
          )}
        </div>
      </div>

      <div className="footer">
        <Footer />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default MisOfertas;
